import HalfHeroHalfSlider from "./HalfHeroHalfSlider"

export default HalfHeroHalfSlider